import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { bundleImages } from "../../../frontend/instant-images-preloader";

import { autocomplete } from "./ReducerAutocomplete";
import { clanCreate } from "./ReducerCreate";
import { clanLeave } from "./ReducerClanLeave";
import { clanRename } from "./ReducerClanRename";
import { introduction } from "./ReducerIntroduction";
import { invites } from "./ReducerInvites";
import { applications } from "./ReducerApp";
import { currentAccount } from "./ReducerCurrentAccount";
import { clanBattles } from "./ReducerBattles";
import { clanEdit } from "./ReducerClanEdit";
import { clans, members, membersOperation, clanProfile } from "./ReducerClanProfile";
import { clansRating } from "./ReducerRatings";
import { fetchingCounter } from "./ReducerProcessing";
import { dialog } from "./ReducerDialog";
import { searchHistory } from "./ReducerSearchHistory";
import { searchResult } from "./ReducerSearch";
import { ReducerRecommendations } from './ReducerRecommendations';
import { ReducerClanTasks } from "./ReducerClanTasks";
import { supply } from "./ReducerBaseSupply";

import { requests } from "./ReducerRequests";
import { ReducerSupply } from "./ReducerSupply";
import { ReducerPromo } from "./ReducerPromo";
import { ReducerClanWars } from "./ReducerClanWars";
import { ReducerClanBattles } from "./ReducerClanBattles";
import { ReducerTreasury } from "./ReducerTreasury";
import { ReducerSettings } from "./ReducerSettings";

const urls = (state = {}) => state;
const content = (state = {}) => state;
const encyclopedia = (state = {}) => state;

export default combineReducers({
  routing: routerReducer,
  bundleImages,

  applications,
  autocomplete,
  clanBattles,
  clanCreate,
  clanEdit,
  clanLeave,
  clanRename,
  clans,
  clansRating,
  currentAccount,
  content,
  dialog,
  fetchingCounter,
  introduction,
  invites,
  members,
  membersOperation,
  searchHistory,
  searchResult,
  settings: ReducerSettings,
  supply,
  ReducerRecommendations,
  ReducerClanTasks,
  requests,
  urls,
  encyclopedia,
  clanProfile,

  ReducerSupply,
  ReducerPromo,
  ReducerClanWars,
  ReducerClanBattles,
  ReducerTreasury
});